import type { QueryHookResult } from '@change-corgi/core-react/async';
import { useQuery } from '@change-corgi/core-react/async';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { getFeaturedPetition } from './api';
import type { FeaturedPetition } from './api';

export type { FeaturedPetition };

type FeaturedPetitionState = QueryHookResult<Readonly<{ petition: FeaturedPetition | null }>>;

type Result = ModelHookResult<{
	featuredPetitionState: FeaturedPetitionState;
}>;

export function useFeaturedPetition(): Result {
	const utilityContext = useUtilityContext();

	return {
		data: {
			featuredPetitionState: useQuery(async () => getFeaturedPetition(utilityContext), [utilityContext]),
		},
	};
}
